import React, {useState} from 'react';
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

const SearchBar = ({ onSearch, placeholder }) => {
  const [query, setQuery] = useState('');

  const onSubmit = () => onSearch(query);

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      onSearch(query);
    }
  }

  return (
    <Input
      fullWidth
      placeholder={placeholder || "Search by Student name..."}
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      onKeyDown={onKeyDown}
      endAdornment={
        <InputAdornment position="end">
          <IconButton onClick={onSubmit}>
            <SearchIcon />
          </IconButton>
        </InputAdornment>
      }
    />
  )
};

export default SearchBar;
